export const STORE_NAMES = {
  PROMOTIONS: 'PromotionsStore',
  SPORTSBOOK: 'SportsbookStore',
  ADV_FILTER: 'AdvFilterStore',
  ADV_FILTER_INNER: 'AdvFilterInnerStore',
  EVENT_HEADER: 'EventHeaderStore',
  RESULTS: 'ResultsStore',
  BETS: 'BetsStore',
  BONUSES: 'BonusesStore',
  FILTERS_STORE: 'FiltersStore',
  PAYMENTS: 'PaymentsStore',
  RESPONSIBLE_GAMBLING: 'ResponsibleGamblingStore',
  AB_TEST: 'ABTestStore',
  IN_HOUSE_JACKPOTS: 'InHouseJackpotsStore',
  VIRTUAL_SPORTS: 'VirtualSportsStore',
  NOTIFICATION_CENTER: 'NotificationCenterStore',
  BETSLIP_LS: 'BetslipLsStore',
  DEVICE: 'DeviceStore',
  NATIVE_APP: 'NativeAppStore',
  I18N: 'I18nStore',
  CRYPTO_RATE: 'CryptoRateStore',
  GAMES_STORE: 'GamesStore',
  CMS_LAYOUT: 'CmsLayout',
  FORTUNE_WHEEL: 'FortuneWheelStore',
  TOURNAMENTS_LEADERBOARDS_STORE: 'TournamentsLeaderboardsStore',
  THEMES: 'ThemeStore'
} as const;

// NB it belongs to SSR package but moved here because of circular deps
export const HTTP_CONTEXT_KEYS = {
  INITIAL_STATE: 'INITIAL_STATE',
  STORES: 'STORES'
} as const;

// eslint-disable-next-line prettier/prettier
export type StrictStoreName = typeof STORE_NAMES[keyof typeof STORE_NAMES];

// eslint-disable-next-line prettier/prettier
export type StoreName = `${StrictStoreName}${string}`
